import type { RefObject } from 'react';

import { Popover } from '~/components/ui';
import { COMMON_EMOJIS } from '~/lib/ai/emojis';

interface EmojiPickerProps {
  anchorRef: RefObject<HTMLElement | null>;
  open: boolean;
  onClose: () => void;
  /** Shown under the grid when an insert would pass the limit; a new `key` is announced again. */
  notice?: { key: number; text: string };
  onSelect: (emoji: string) => void;
  testId: string;
}

/** The emoji button's popup: a fixed grid of common emoji. */
export function EmojiPicker({
  anchorRef,
  open,
  onClose,
  notice,
  onSelect,
  testId,
}: EmojiPickerProps) {
  return (
    <Popover
      anchorRef={anchorRef}
      open={open}
      onClose={onClose}
      placement="bottom-end"
      ariaLabel="Emoji"
      testId={testId}
      className="w-72 p-2"
    >
      <div className="grid grid-cols-8 gap-1">
        {COMMON_EMOJIS.map((emoji) => (
          <button
            key={emoji}
            type="button"
            aria-label={`Insert ${emoji}`}
            className="focus-ring flex size-8 items-center justify-center rounded-lg text-base hover:bg-gray-100 dark:hover:bg-white/5"
            onClick={() => onSelect(emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
      {notice ? (
        <p
          key={notice.key}
          role="alert"
          className="mt-2 text-xs text-error-600 dark:text-error-400"
        >
          {notice.text}
        </p>
      ) : null}
    </Popover>
  );
}
